export function scrollToUniversities() {
  const section = document.getElementById('universities');
  if (!section) {
    return false;
  }

  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}
